// extracted by mini-css-extract-plugin
export default {"statItems":"statistic-items_statItems__bOVUp","statsRow":"statistic-items_statsRow__sGX7M"};